//
// 消息提示框
// ============================================================
import Ns from "./utility";

let touchStart, prevTouch, touchMove;

const Nav = options => {
    new Ns({
        el: "body",
        eventHandle: {
            type: "click",
            entrust: ".show-nav-button",
            callback:  function (ev) {
                ns(".nav-wrapper").addClass("active").find(".nav-list").removeAttr("style");
                return true;
            }
        }
    });
    new Ns({
        el: ".nav-wrapper",
        eventHandle: [ {
            type: "touchstart",
            callback:  function (ev) {
                ns("body").addClass("overflow-hidden");
                touchStart = ev.changedTouches[0].pageX;
                ns(this).find(".nav-list").removeClass("transition-1s");
                return true;
            }
        }, {
            type: "touchmove",
            callback:  function (ev) {
                let move = ev.changedTouches[0].pageX - touchStart;
                touchMove = move <= 0 ? move : 0;
                let backgroundValue = (1 + (touchMove / ns(this).find(".nav-list").getStyle("width"))) * .3;
                ns(this).css("background", "rgba(0, 0, 0, " + backgroundValue + ")").find(".nav-list").css("left", touchMove + "px");
                return true;
            }
        }, {
            type: "touchend",
            callback:  function (ev) {
                let navListWidth = ns(this).find(".nav-list").addClass("transition-1s").getStyle("width");

                if(-navListWidth/2 < touchMove) {
                    ns(this).find(".nav-list").css("left", "0");
                }else {
                    ns(this).css("background", "rgba(0, 0, 0, 0)").find(".nav-list").css("left", "-100%");
                    setTimeout( () => ns(this).removeClass('active').removeAttr("style"), 500 )
                }

                ns("body").removeClass("overflow-hidden");
                return true;
            }
        }],
        callback() {
        }
    });
};

module.exports = Nav;


// WEBPACK FOOTER //
// src/js/nav.js